export default __webpack_public_path__ + "static/media/google.1063b9c6.webp";